<template>
    <form class="form3" v-if="loaded || isNewPage">
        <div class="formGroup" v-if="!isNewPage" style="margin-bottom: 10px">
            <button
                v-if="!editMode"
                @click.prevent="editMode = true"
                class="button half dark"
                type="button"
                name="button"
            >
                Edit
            </button>
            <button
                v-if="!editMode"
                @click.prevent="deleteOffer"
                class="button half red"
                type="button"
                name="button"
            >
                Delete
            </button>
        </div>

        <div v-if="editMode">
            <div class="formGroup" @submit.prevent>
                <label>Title:</label>
                <input
                    v-model="form.title"
                    :class="{ selected: form.title }"
                    maxlength="255"
                    type="text"
                    placeholder="Your offer title goes here"
                />
                <has-error class="info error" :form="form" field="title" />
            </div>

            <div class="formGroup">
                <label>Category:</label>
                <div class="select">
                    <select v-model="form.category_id" :class="{ selected: form.category_id }">
                        <option value="">Choose an offer category</option>
                        <option
                            :value="category.id"
                            v-for="category in categories"
                            :key="category.id"
                        >
                            {{ category.name }}
                        </option>
                    </select>
                    <img class="arrow" src="@/assets/arrow-right-white.svg" alt="" />
                </div>
                <has-error class="info error" :form="form" field="category_id" />
            </div>

            <div class="formGroup" style="position: relative">
                <label>Images:</label>

                <div v-for="(image, index) in form.images" :key="index" style="margin-bottom: 20px">
                    <img class="thumbnail" :src="imageURL(image)" />
                    <button @click.prevent="removeImage(index)" type="button" class="button red">
                        Delete image
                    </button>
                </div>

                <android-file-picker
                    id="content-offer"
                    mode="single"
                    type="Image"
                    v-if="androidFilePickerOpen"
                ></android-file-picker>
                <label @click="openFileAndroid" class="button dark fileInput">
                    <input
                        @change="addImage"
                        type="file"
                        name=""
                        value=""
                        accept="image/x-png,image/gif,image/jpeg,image/jpg"
                    />
                    Add Image
                    <img class="plus" src="@/assets/arrow-plus-white.svg" />
                </label>

                <has-error class="info error" :form="form" field="image_files" />
                <has-error class="info error" :form="form" field="image_files.0" />
            </div>

            <div class="formGroup">
                <label>Description:</label>

                <textarea-autosize
                    :class="{ selected: form.description }"
                    placeholder="Your offer description goes here"
                    v-model="form.description"
                    name="name"
                />
                <has-error class="info error" :form="form" field="description" />
            </div>

            <div class="formGroup">
                <label>Price:</label>

                <currency-input
                    :class="{ selected: form.price }"
                    class="currencyInput"
                    maxlength="6"
                    v-model="form.price"
                    placeholder="Add price"
                    :currency="$store.state.user.currency"
                />
                <has-error class="info error" :form="form" field="price" />
            </div>

            <div class="formGroup">
                <label>Lesson credit value:</label>

                <div class="select">
                    <input
                        type="number"
                        v-model="form.lesson_credits_value"
                        :class="{ selected: form.lesson_credits_value }"
                    />
                    <!--<img class="arrow" src="@/assets/arrow-right-white.svg" alt="">-->
                </div>
            </div>

            <div class="formGroup">
                <label>Qty:</label>
                <input type="number" v-model="form.qty" />

                <!--<div class="select" >
          <select class="button light" v-model="form.button_type" :class="{selected:form.button_type}">
                <option value="">Select button type</option>
                <option value="Book now">Book now</option>
                <option value="Buy Now">Buy Now</option>
          </select>
          <img class="arrow" src="@/assets/arrow-right-white.svg" alt="">
          
          
        </div>-->

                <input type="hidden" v-model="form.button_type" value="Buy Now" />

                <has-error class="info error" :form="form" field="qty" />
            </div>

            <div class="formGroup half">
                <label>Offer starts:</label>
                <input
                    style="height: 52px"
                    type="date"
                    v-model="form.started_at"
                    :class="{ selected: form.started_at }"
                />
                <has-error class="info error" :form="form" field="started_at" />
            </div>

            <div class="formGroup half" style="margin-bottom: 30px">
                <label>Offer ends:</label>
                <input
                    style="height: 52px"
                    type="date"
                    v-model="form.ended_at"
                    :class="{ selected: form.ended_at }"
                />
                <has-error class="info error" :form="form" field="ended_at" />
            </div>

            <button
                :disabled="form.busy"
                v-if="isNewPage"
                class="button mb10"
                @click.prevent="saveOffer"
                type="submit"
                name="button"
            >
                {{ form.busy ? "Please wait..." : "Create offer" }}
            </button>

            <button
                class="button mb10"
                v-if="!isNewPage"
                type="button"
                name="button"
                @click.prevent="updateOffer"
            >
                {{ form.busy ? "Please wait..." : "Update offer" }}
            </button>

            <button
                v-if="editMode"
                type="button"
                @click.prevent="editMode = false"
                class="button red mb10"
                name="button"
            >
                Cancel
            </button>

            <button
                class="button red mb30"
                @click.prevent="deleteOffer"
                v-if="!isNewPage"
                type="button"
                name="button"
            >
                {{ form.busy ? "Please wait..." : "Delete offer" }}
            </button>
        </div>

        <div v-else>
            <template v-for="image in form.images">
                <div class="thumbnailSurround" :key="image">
                    <img class="thumbnail" :src="imageURL(image)" />
                </div>
            </template>

            <div class="copy">
                <p>{{ form.description }}</p>
            </div>

            <span class="price">{{
                form.price | currency({ symbol: $store.state.user.currencySymbol })
            }}</span>

            <span v-if="form.button_type" class="button center">{{ form.button_type }}</span>
        </div>
    </form>

    <div v-else>
        <pre-loader-item v-for="n in 5" :key="n" />
    </div>
</template>

<script>
import AndroidFilePicker from "@/components/Shared/Android-file-picker";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import { imageURL } from "@/mixins/imageURL.js";
import { Form, HasError } from "vform";
import objectToFormData from "object-to-formdata";
import { isAndroid } from "mobile-device-detect";
import { dataURLToFile } from "@/mixins/dataURLtoFile.js";
export default {
    components: { AndroidFilePicker, PreLoaderItem, HasError },
    mixins: [imageURL, dataURLToFile],
    watch: {
        editMode(val) {
            this.$emit("onEdit", val);
        },
    },
    computed: {
        categories() {
            return this.$store.state.categories;
        },
        isNewPage() {
            return this.$route.name == "proOffersNew";
        },
    },
    created() {
        if (this.categories.length == 0) {
            this.$store.dispatch("getCategories");
        }
        if (this.isNewPage) {
            this.editMode = true;
        }
        if (!this.isNewPage) {
            this.getOffer();
            this.form.method = "put";
        }

        this.oWebViewInterface.on("fileRecieved-content-offer", (imageData) => {
            if (!this.form.image_files) {
                this.form.image_files = [];
            }
            if (!this.form.images) {
                this.form.images = [];
            }

            // Match addImage(): thumbnails render from form.images, uploads from form.image_files.
            var file = this.dataURLToFile(
                "data:image/png;base64," + imageData,
                "offer-image.png",
            );
            let imageFileIndex = this.form.image_files.push(file);
            let imageIndex = this.form.images.push(URL.createObjectURL(file));
            this.imageToImageFileMap[imageIndex - 1] = imageFileIndex - 1;
            this.androidFilePickerOpen = false;
        });
    },
    data() {
        return {
            loaded: false,
            editMode: false,
            oWebViewInterface: window.nsWebViewInterface,
            androidFilePickerOpen: false,
            imageToImageFileMap: [],
            form: new Form({
                title: "",
                qty: "",
                category_id: "",
                description: "",
                button_type: "Buy Now",
                image_files: [],
                images: [],
                price: 0,
                started_at: "",
                ended_at: "",
                lesson_credits_value: "",
                _method: "post",
            }),
        };
    },
    methods: {
        openFileAndroid() {
            if (isAndroid) {
                this.androidFilePickerOpen = true;
            }
        },
        removeImage(index) {
            let imageToDelete = this.form.images[index];
            this.form.images = this.form.images.filter((image) => image != imageToDelete);
            if (this.form.image_files) {
                if (typeof this.imageToImageFileMap[index] != "undefined") {
                    let imageFileIndex = this.imageToImageFileMap[index];
                    this.form.image_files.splice(imageFileIndex, 1);
                }
            }
        },
        deleteOffer() {
            this.$confirm("Are you sure you want to delete this offer?", () => {
                this.form.delete("/offer/" + this.$route.params.id).then(() => {
                    this.$store.dispatch("deleteOffer", this.form);
                    this.$router.push({ name: "proOffers" });
                    this.$notify({
                        text: "Offer deleted",
                    });
                });
            });
        },
        addImage() {
            if (!this.form.image_files) {
                this.form.image_files = [];
            }
            if (!this.form.images) {
                this.form.images = [];
            }
            var file = event.target.files[0];
            let imageFileIndex = this.form.image_files.push(file);
            let imageIndex = this.form.images.push(URL.createObjectURL(file));
            this.imageToImageFileMap[imageIndex - 1] = imageFileIndex - 1;
        },
        getOffer() {
            this.form.get("/offer/" + this.$route.params.id).then((offer) => {
                this.form.fill(offer.data);
                this.$emit("onOfferLoaded", offer.data);
                this.loaded = true;
            });
        },
        saveOffer() {
            this.form
                .submit("post", "/offer", {
                    transformRequest: [
                        function (data) {
                            data.images = data.images.filter(
                                (image) => image.substring(0, 4) != "blob",
                            );
                            if (!data.image_files || !data.image_files.length) {
                                delete data.image_files;
                            }
                            return objectToFormData(data);
                        },
                    ],
                })
                .then((offer) => {
                    this.$emit("onSaved");
                    this.$store.dispatch("addOffer", offer.data);
                    this.$router.push({ name: "proOffers" });
                    this.$notify({
                        text: "Your offer has been created",
                    });
                });
        },
        updateOffer() {
            this.form["_method"] = "put";
            console.log(this.form);
            this.form
                .submit("post", "/offer/" + this.$route.params.id, {
                    transformRequest: [
                        function (data) {
                            data.images = data.images.filter(
                                (image) => image.substring(0, 4) != "blob",
                            );
                            if (!data.image_files || !data.image_files.length) {
                                delete data.image_files;
                            }
                            return objectToFormData(data);
                        },
                    ],
                })
                .then((offer) => {
                    this.$store.dispatch("updateOffer", offer.data);
                    this.$router.push({ name: "proOffers" });
                    this.$notify({
                        text: "Your offer has been updated",
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.fileInput {
    color: white !important;
    padding: 14px 20px;
    input[type="file"] {
        display: none;
    }
}
.thumbnail {
    border-radius: 12px;
    width: 100%;
    margin-bottom: 20px;
}
.plus {
    float: right;
    margin-top: 5px;
}
.arrow {
    position: absolute;
    right: 20px;
    top: 18px;
    pointer-events: none;
}
.copy {
    background: white;
    padding: 20px;
    border-radius: 12px;
    color: $green_0;
    white-space: pre-line;
}
.price {
    font-size: 26px;
    color: $green_0;
    margin: 30px;
    text-align: center;
    display: block;
}
.thumbnail {
    width: 100%;
    border-radius: $radius;
}
</style>
